import * as React from "react";
export const ComponentDisposer = () => React.createElement(React.Fragment, null);
//# sourceMappingURL=ComponentDisposer.js.map